<template>
  <div class="page flex-col">

    <div class="section_2 flex-col">
      <div class="box_1 flex-col">
        <div class="image-wrapper_1 flex-row">
          <img
            class="image_2"
            referrerpolicy="no-referrer"
            v-lazy="'https://web-cdn.ktangtang.com/official-website/solution_h5/FigmaDDSSlicePNG7ba570a83befcbe064b13fb9d24088c8.png'"
          />
          <img
            class="image_3"
            referrerpolicy="no-referrer"
            v-lazy="'https://web-cdn.ktangtang.com/official-website/solution_h5/FigmaDDSSlicePNG6a94e3f80b0a881a2f82b16ad3e3a8f8.png'"
          />
          <div style="margin-left: -32vw"> <headerMask/> </div>
        </div>
   
      </div>
      <div class="text-group_1 flex-col justify-between">
        <span class="paragraph_1">
          从大型康养机构、康复科到康复师、健身教练个人
          <br />
          我们都提供适合他们的解决方案
          <br />
        </span>
        <span class="text_2">开运动处方找以动就够了</span>
      </div>
    </div>
    <div class="section_3 flex-col">
      <div class="box_2 flex-row">
        <div class="box_3 flex-col"></div>
        <img
          class="thumbnail_3"
          referrerpolicy="no-referrer"
          v-lazy="'https://web-cdn.ktangtang.com/official-website/solution_h5/159137247691434f826f51f0f519ae2c_mergeImage.png'"
        />
        <div class="image-text_1 flex-row">
          <div class="box_4 flex-col"></div>
          <span class="text-group_2">康复逻辑流程</span>
          <div class="image-wrapper_2 flex-col">
            <img
              class="thumbnail_4"
              referrerpolicy="no-referrer"
              v-lazy="'https://web-cdn.ktangtang.com/official-website/solution_h5/FigmaDDSSlicePNG0efce337b16177f7b543ef01704cf6f6.png'"
            />
          </div>
        </div>
      </div>
    </div>
    <div class="section_4 flex-col">
      <div class="group_1 flex-row">
        <div class="image-text_2 flex-col justify-between">
          <img
            class="label_f2"
            referrerpolicy="no-referrer"
            v-lazy="'https://web-cdn.ktangtang.com/official-website/solution_h5/FigmaDDSSlicePNGc0400e46ffdd90e09fdecd6d54508c5c.png'"
          />
          <span class="text-group_3">
            患者手机端康复小程序
            <br />
            实时上传患者数据及查看运动处方
          </span>
        </div>
      </div>
      <div class="group_2 flex-row">
        <div class="text-wrapper_1 flex-col"><span class="text_3">移动端APP</span></div>
      </div>
      <div class="group_3 flex-row">
        <div class="section_5 flex-col justify-between">
          <div class="box_5 flex-row justify-between">
            <div class="image-wrapper_3 flex-col justify-between">
              <img
                class="image_4"
                referrerpolicy="no-referrer"
                v-lazy="'https://web-cdn.ktangtang.com/official-website/solution_h5/FigmaDDSSlicePNGb8ac97dd1b4a7b7800e308b5e70bf6bd.png'"
              />
              <img
                class="image_5"
                referrerpolicy="no-referrer"
                v-lazy="'https://web-cdn.ktangtang.com/official-website/solution_h5/FigmaDDSSlicePNG7632b630d0c5c02fb51b8da5aa776e96.png'"
              />
            </div>
            <div class="text-wrapper_2 flex-col"><span class="text_4">评估设备</span></div>
          </div>
          <span class="text_5">体适能评估和关节角度评估设备</span>
        </div>
        <div class="section_6 flex-col">
          <div class="box_6 flex-row justify-between">
            <span class="paragraph_2">
              报
              <br />
              告
              <br />
              输
              <br />
              出
            </span>
            <img
              class="image_6"
              referrerpolicy="no-referrer"
              v-lazy="'https://web-cdn.ktangtang.com/official-website/solution_h5/6b6af7ed9742479abf67fc6939b95567_mergeImage.png'"
            />
            <span class="paragraph_3">
              实
              <br />
              时
              <br />
              共
              <br />
              享
            </span>
          </div>
          <div class="box_7 flex-row">
            <div class="text-wrapper_3 flex-col justify-between">
              <span class="text_6">命令下达</span>
              <span class="text_7">数据上传</span>
            </div>
            <div class="image-wrapper_4 flex-col">
              <img
                class="image_7"
                referrerpolicy="no-referrer"
                v-lazy="'https://web-cdn.ktangtang.com/official-website/solution_h5/left.png'"
              />
              <img
                class="image_w7"
                referrerpolicy="no-referrer"
                v-lazy="'https://web-cdn.ktangtang.com/official-website/solution_h5/right.png'"
              />
            </div>
            <div class="text-wrapper_4 flex-col justify-between">
              <span class="text_8">处方下达</span>
              <span class="text_9">数据上传</span>
            </div>
          </div>
          <span class="text_10">系统及工作站</span>
          <div class="text-wrapper_5 flex-col"><span class="text_11">数据中心及系统</span></div>
        </div>
        <div class="text-wrapper_6 flex-col">
          <span class="paragraph_4">
            运
            <br />
            动
            <br />
            设
            <br />
            备
          </span>
        </div>
        <div class="image-text_3 flex-col justify-between">
          <img
            class="image_8"
            referrerpolicy="no-referrer"
            v-lazy="'https://web-cdn.ktangtang.com/official-website/solution_h5/FigmaDDSSlicePNG1ea77a64c8703af999fc19b1593bab5f.png'"
          />
          <span class="text-group_4">功率车和四肢联动设备等</span>
        </div>
      </div>
      <div class="group_4 flex-row justify-between">
        <span class="paragraph_5">
          实
          <br />
          时
          <br />
          连
          <br />
          接
        </span>
        <img
          class="image_9"
          referrerpolicy="no-referrer"
          v-lazy="'https://web-cdn.ktangtang.com/official-website/solution_h5/dcd9c7e9b5b9441e86f082a3b23d3763_mergeImage.png'"
        />
        <span class="paragraph_6">
          数
          <br />
          据
          <br />
          上
          <br />
          传
        </span>
      </div>
      <div class="group_5 flex-row">
        <div class="text-wrapper_7 flex-col"><span class="text_12">评运动中的安全设备</span></div>
      </div>
      <div class="group_6 flex-row">
        <div class="image-text_4 flex-col justify-between">
          <img
            class="label_3"
            referrerpolicy="no-referrer"
            v-lazy="'https://web-cdn.ktangtang.com/official-website/solution_h5/FigmaDDSSlicePNGcbba6f70e0f04a77c7bafdf26d5c1ed4.png'"
          />
          <span class="text-group_5">心率监控手环等</span>
        </div>
      </div>
      <div style="margin-top: -4vw">
      <img
        class="image_10"
        referrerpolicy="no-referrer"
        v-lazy="'https://web-cdn.ktangtang.com/official-website/solution_h5/right.png'"
      />
      <img
        class="image_w10"
        referrerpolicy="no-referrer"
        v-lazy="'https://web-cdn.ktangtang.com/official-website/solution_h5/left.png'"
      />
    </div>
    </div>
    <div class="section_7 flex-col">
      <div class="box_8 flex-row">
        <div class="box_9 flex-col"></div>
        <img
          class="thumbnail_5"
          referrerpolicy="no-referrer"
          v-lazy="'https://web-cdn.ktangtang.com/official-website/solution_h5/bdfef1403b1149559691900b6a140037_mergeImage.png'"
        />
        <div class="image-text_5 flex-row">
          <div class="block_1 flex-col"></div>
          <span class="text-group_6">在医疗机构的开展情况</span>
          <div class="image-wrapper_5 flex-col">
            <img
              class="thumbnail_6"
              referrerpolicy="no-referrer"
              v-lazy="'https://web-cdn.ktangtang.com/official-website/solution_h5/FigmaDDSSlicePNG0efce337b16177f7b543ef01704cf6f6.png'"
            />
          </div>
        </div>
      </div>
      <div class="text-wrapper_8">
        <span class="paragraph_7">
          北京大学第一医院内分泌科病房体医融合
          <br />
          运动指导工作站SMIS
          <br />
        </span>
        <span class="text_13">Sports&nbsp;and&nbsp;Medicine&nbsp;Integration&nbsp;Station</span>
      </div>
      <span class="paragraph_8">
        &nbsp;&nbsp;&nbsp;&nbsp;为了解决好首都人民健康的根本需求，建立“健康北京，体医融合“的新模式，以动健康、北京体育局与北京大学第一医院内分泌科以及建立数字化运动康复中心，服务患者数千人，改善了他们的三高状况和生活质量，一类学术期刊发布论文数篇。
        <br />
      </span>
      <div class="image-wrapper_6 flex-row justify-between">
        <img
          class="image_11"
          referrerpolicy="no-referrer"
          v-lazy="'https://web-cdn.ktangtang.com/official-website/solution_h5/FigmaDDSSlicePNGc3dcc236a056f02be252438813eb46aa.png'"
        />
        <img
          class="image_12"
          referrerpolicy="no-referrer"
          v-lazy="'https://web-cdn.ktangtang.com/official-website/solution_h5/FigmaDDSSlicePNG93f85eb9c38e86ed17a6c34b4c955eef.png'"
        />
        <img
          class="image_13"
          referrerpolicy="no-referrer"
          v-lazy="'https://web-cdn.ktangtang.com/official-website/solution_h5/FigmaDDSSlicePNGfe348bd612cf559bbaae2c7d9fc35f12.png'"
        />
      </div>
      <span class="paragraph_9">
        中日医院“治未病”健康管理中心
        <br />
        运动康复站
        <br />
      </span>
      <span class="paragraph_10">
        &nbsp;&nbsp;&nbsp;&nbsp;中日医院治未病门诊针对体检后存在慢病风险、亚健康人群。运用疾病风险评估，生活方式干预、危险因素控制药物治疗以及中医适宜技术等综合手段，实现早防，早诊，早治，延缓疾病的发生，提高生活质量，促进健康的目的。在2020年建立了运动康复工作站。通过特色评估，开具个性化运动处方，进行线上线下运动管理和干预。
        <br />
      </span>
      <div class="image-wrapper_7 flex-row justify-between">
        <img
          class="image_14"
          referrerpolicy="no-referrer"
          v-lazy="'https://web-cdn.ktangtang.com/official-website/solution_h5/FigmaDDSSlicePNG6c6729d721d73e827567f0f41953e624.png'"
        />
        <img
          class="image_15"
          referrerpolicy="no-referrer"
          v-lazy="'https://web-cdn.ktangtang.com/official-website/solution_h5/FigmaDDSSlicePNG425a8f7722b2e0e9e62a426b1b1598c6.png'"
        />
        <img
          class="image_16"
          referrerpolicy="no-referrer"
          v-lazy="'https://web-cdn.ktangtang.com/official-website/solution_h5/FigmaDDSSlicePNG7a204813cbafa736e99958bd2589f04b.png'"
        />
      </div>
      <div class="box_10 flex-row">
        <div class="box_11 flex-col"></div>
        <img
          class="thumbnail_7"
          referrerpolicy="no-referrer"
          v-lazy="'https://web-cdn.ktangtang.com/official-website/solution_h5/d5502fce376141709eb8c52f8b46ee3c_mergeImage.png'"
        />
        <div class="image-text_6 flex-row justify-between">
          <div class="box_12 flex-col">
            <div class="box_13 flex-col"></div>
            <span class="text-group_7">在健康管理机构的应用案例</span>
          </div>
          <div class="image-wrapper_8 flex-col">
            <img
              class="thumbnail_8"
              referrerpolicy="no-referrer"
              v-lazy="'https://web-cdn.ktangtang.com/official-website/solution_h5/FigmaDDSSlicePNG0efce337b16177f7b543ef01704cf6f6.png'"
            />
          </div>
        </div>
      </div>
      <span class="paragraph_11">
        云南省体育医院数字化运动康复中心
        <br />
      </span>
      <span class="paragraph_12">
        &nbsp;&nbsp;&nbsp;&nbsp;云南省体育运动创伤专科医院属云南省体育局直属处级单位。目前在全国为第六家运动创伤专科医院。为了利用移动互联网，智能设备，远程医疗、大数据等技术，打造线上线下结合的健康运动管理服务新模式，建立了云南体育医院数字化运动康复中心SMIC。
        <br />
      </span>
      <div class="image-wrapper_9 flex-row justify-between">
        <img
          class="image_17"
          referrerpolicy="no-referrer"
          v-lazy="'https://web-cdn.ktangtang.com/official-website/solution_h5/FigmaDDSSlicePNG62f51ed25390b5f4e6471de7571b0cef.png'"
        />
        <img
          class="image_18"
          referrerpolicy="no-referrer"
          v-lazy="'https://web-cdn.ktangtang.com/official-website/solution_h5/FigmaDDSSlicePNG3864d90fd69dd1b712c8b23554f9d660.png'"
        />
        <img
          class="image_19"
          referrerpolicy="no-referrer"
          v-lazy="'https://web-cdn.ktangtang.com/official-website/solution_h5/FigmaDDSSlicePNG7548e97865cd0e1b0919c4fb3ddfb443.png'"
        />
      </div>
      <span class="paragraph_13">
        北京顺义“妙健康”金茂怡生园加拿大健康管理中心（CWI）
        <br />
      </span>
      <div class="text-wrapper_9">
        <span class="text_14">&nbsp;&nbsp;&nbsp;</span>
        <span class="paragraph_14">
          妙健康为国内前五的健康管理企业，加拿大健康管理中心是妙健康与加拿大健康管理中心合作的国内领先的健康管理中心。建设过程融入了SMIC，并搭建了物联网科技和康复器械，研发了三高的运动处方。项目落成后，加拿大健康管理中心模式已经在全国五个城市落地，带来了广泛的社会和经济效益。
          <br />
        </span>
      </div>
      <div class="image-wrapper_10 flex-row justify-between">
        <img
          class="image_20"
          referrerpolicy="no-referrer"
          v-lazy="'https://web-cdn.ktangtang.com/official-website/solution_h5/FigmaDDSSlicePNG9a3e9a6547342f3b94b1fcd8aac2c1e1.png'"
        />
        <img
          class="image_21"
          referrerpolicy="no-referrer"
          v-lazy="'https://web-cdn.ktangtang.com/official-website/solution_h5/FigmaDDSSlicePNGc8466b51316ec9d69fbe9e577ae5db74.png'"
        />
        <img
          class="image_22"
          referrerpolicy="no-referrer"
          v-lazy="'https://web-cdn.ktangtang.com/official-website/solution_h5/FigmaDDSSlicePNGaf966fc34c62aabf59d77d534b517308.png'"
        />
      </div>
      <div class="box_14 flex-row">
        <div class="block_2 flex-col"></div>
        <img
          class="thumbnail_9"
          referrerpolicy="no-referrer"
          v-lazy="'https://web-cdn.ktangtang.com/official-website/solution_h5/03f663fa7254490daafa1e33f59bcb05_mergeImage.png'"
        />
        <div class="image-text_7 flex-row justify-between">
          <div class="group_7 flex-col">
            <div class="section_8 flex-col"></div>
            <span class="text-group_8">在健康企业中的应用案例</span>
          </div>
          <div class="image-wrapper_11 flex-col">
            <img
              class="thumbnail_10"
              referrerpolicy="no-referrer"
              v-lazy="'https://web-cdn.ktangtang.com/official-website/solution_h5/FigmaDDSSlicePNG0efce337b16177f7b543ef01704cf6f6.png'"
            />
          </div>
        </div>
      </div>
      <span class="paragraph_15">
        深圳蛇口招商健康美伦门诊部体医融合专病中心
        <br />
      </span>
      <div class="text-wrapper_10">
        <span class="text_15">&nbsp;&nbsp;&nbsp;</span>
        <span class="paragraph_16">
          招商美伦健康作为一个健康管理机构，现在正处于由体检中心向全生命周期健康管理业务转型的关键阶段。2020年，力求打造专业化的健康管理中心，成立了数字化运动康复中心，为各企业或客户带来更加专业的全方位全生命周期的健康管理服务
          <br />
        </span>
      </div>
      <div class="image-wrapper_12 flex-row justify-between">
        <img
          class="image_23"
          referrerpolicy="no-referrer"
          v-lazy="'https://web-cdn.ktangtang.com/official-website/solution_h5/FigmaDDSSlicePNGbe09742525141a60dd5ee2b09f44a270.png'"
        />
        <img
          class="image_24"
          referrerpolicy="no-referrer"
          v-lazy="'https://web-cdn.ktangtang.com/official-website/solution_h5/FigmaDDSSlicePNGdd4e0e12e29c14940169c960c4a8d0e8.png'"
        />
        <img
          class="image_25"
          referrerpolicy="no-referrer"
          v-lazy="'https://web-cdn.ktangtang.com/official-website/solution_h5/FigmaDDSSlicePNGc404cb8a87f69759abdbccf185de9850.png'"
        />
        <img
          class="image_26"
          referrerpolicy="no-referrer"
          v-lazy="'https://web-cdn.ktangtang.com/official-website/solution_h5/FigmaDDSSlicePNGb0a7a6151776d86f180bfee965b72e26.png'"
        />
        <img
          class="image_27"
          referrerpolicy="no-referrer"
          v-lazy="'https://web-cdn.ktangtang.com/official-website/solution_h5/FigmaDDSSlicePNG8e8c14c0e3078e3a692a809e5ca0e91b.png'"
        />
        <img
          class="image_28"
          referrerpolicy="no-referrer"
          v-lazy="'https://web-cdn.ktangtang.com/official-website/solution_h5/FigmaDDSSlicePNG503de70759bbeb2b0aaa2d7b638314ca.png'"
        />
      </div>
      <span class="text_16">深圳南山区华润置地企业健康管理中心</span>
      <div class="text-wrapper_11">
        <span class="text_17">&nbsp;&nbsp;&nbsp;</span>
        <span class="paragraph_17">
          以企业职场运动评估干预方案为核心载体共同建立具备专业医学知识框架、符合新一代信息技术要求、满足用户切实需求的企业职场健康管理和风险预警的企业职场运动康复专业内容和领先软件硬件平台。
          <br />
        </span>
      </div>
      <div class="image-wrapper_13 flex-row justify-between">
        <img
          class="image_29"
          referrerpolicy="no-referrer"
          v-lazy="'https://web-cdn.ktangtang.com/official-website/solution_h5/FigmaDDSSlicePNG89dc74b1e5135231930e6dc19e66ab83.png'"
        />
        <img
          class="image_30"
          referrerpolicy="no-referrer"
          v-lazy="'https://web-cdn.ktangtang.com/official-website/solution_h5/FigmaDDSSlicePNG7b84702c0c609f94c77c226fddd0b65f.png'"
        />
      </div>
      <div class="box_15 flex-row">
        <div class="block_3 flex-col"></div>
        <img
          class="thumbnail_11"
          referrerpolicy="no-referrer"
          v-lazy="'https://web-cdn.ktangtang.com/official-website/solution_h5/d15761b0b4d147bebabf64c70de9d5fc_mergeImage.png'"
        />
        <div class="image-text_8 flex-row justify-between">
          <div class="group_8 flex-col">
            <div class="group_9 flex-col"></div>
            <span class="text-group_9">在社区中的应用案例</span>
          </div>
          <div class="image-wrapper_14 flex-col">
            <img
              class="thumbnail_12"
              referrerpolicy="no-referrer"
              v-lazy="'https://web-cdn.ktangtang.com/official-website/solution_h5/FigmaDDSSlicePNG0efce337b16177f7b543ef01704cf6f6.png'"
            />
          </div>
        </div>
      </div>
      <span class="paragraph_18">
        北京大兴清源路街道养老社区SMIC
        <br />
      </span>
      <div class="text-wrapper_12">
        <span class="text_18">&nbsp;&nbsp;&nbsp;</span>
        <span class="paragraph_19">
          为提高养老服务内容，以智能技术为手段，实现养老机构管理全覆盖，老人服务全覆盖，形成生活照料、文娱社交、健康管理、安全居住一体化的生态养老环境，2020年北京市大兴区清源路街道办事处，打造健康管理智能化系统，建立北京大兴清源路街道养老社区SMIC。
          <br />
        </span>
      </div>
      <div class="image-wrapper_15 flex-row">
        <img
          class="image_31"
          referrerpolicy="no-referrer"
          v-lazy="'https://web-cdn.ktangtang.com/official-website/solution_h5/FigmaDDSSlicePNGab64dca986a066375811feb549d3dd2b.png'"
        />
        <img
          class="image_32"
          referrerpolicy="no-referrer"
          v-lazy="'https://web-cdn.ktangtang.com/official-website/solution_h5/FigmaDDSSlicePNG587eac5555c64cb01ce6dbb9a91f5312.png'"
        />
        <img
          class="image_33"
          referrerpolicy="no-referrer"
          v-lazy="'https://web-cdn.ktangtang.com/official-website/solution_h5/FigmaDDSSlicePNG85d8450a18ddbbf5f13975426412ea1c.png'"
        />
      </div>
      <span class="paragraph_20">
        上海尚体“乐活空间”SMIC
        <br />
      </span>
      <div class="text-wrapper_13">
        <span class="text_19">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>
        <span class="paragraph_21">
          为了帮助老年人预防和减缓慢性疾病的发生与发展，提高老年人的生活品质。在上海尚体“乐活空间”建立SMIC，打造老年人“举步可就”的“10分钟社区健康生活圈”，解决了老年人去哪儿科学健身的问题和情感孤独问题，提高老年人健康认知和素养，形成社区老年人运动健康促进服务模式，充分发挥全民科学健身在健康促进、慢性病预防和康复等方面的积极作用。
          <br />
        </span>
      </div>
      <div class="image-wrapper_16 flex-row">
        <img
          class="image_34"
          referrerpolicy="no-referrer"
          v-lazy="'https://web-cdn.ktangtang.com/official-website/solution_h5/FigmaDDSSlicePNGab64dca986a066375811feb549d3dd2b.png'"
        />
        <img
          class="image_35"
          referrerpolicy="no-referrer"
          v-lazy="'https://web-cdn.ktangtang.com/official-website/solution_h5/FigmaDDSSlicePNG587eac5555c64cb01ce6dbb9a91f5312.png'"
        />
        <img
          class="image_36"
          referrerpolicy="no-referrer"
          v-lazy="'https://web-cdn.ktangtang.com/official-website/solution_h5/FigmaDDSSlicePNG85d8450a18ddbbf5f13975426412ea1c.png'"
        />
      </div>
      <div class="box_16 flex-row">
        <div class="block_4 flex-col"></div>
        <img
          class="thumbnail_13"
          referrerpolicy="no-referrer"
          v-lazy="'https://web-cdn.ktangtang.com/official-website/solution_h5/8219ddb69f5b486a855239b715de86fd_mergeImage.png'"
        />
        <div class="image-text_9 flex-row justify-between">
          <div class="box_17 flex-col">
            <div class="block_5 flex-col"></div>
            <span class="text-group_10">典型项目案例展示</span>
          </div>
          <div class="image-wrapper_17 flex-col">
            <img
              class="thumbnail_14"
              referrerpolicy="no-referrer"
              v-lazy="'https://web-cdn.ktangtang.com/official-website/solution_h5/FigmaDDSSlicePNG0efce337b16177f7b543ef01704cf6f6.png'"
            />
          </div>
        </div>
      </div>
      <div class="image-wrapper_18 flex-row">
        <img
          class="thumbnail_15"
          referrerpolicy="no-referrer"
          v-lazy="'https://web-cdn.ktangtang.com/official-website/solution_h5/FigmaDDSSlicePNG075ce7ed400dc9c1683ddc509a884e1f.png'"
        />
        <img
          class="image_37"
          referrerpolicy="no-referrer"
          v-lazy="'https://web-cdn.ktangtang.com/official-website/solution_h5/FigmaDDSSlicePNG92865307e079109c55ce86e1a50a1141.png'"
        />
        <img
          class="image_38"
          referrerpolicy="no-referrer"
          v-lazy="'https://web-cdn.ktangtang.com/official-website/solution_h5/FigmaDDSSlicePNGca4d46e6bebd85a82a4edb60bf79b4c7.png'"
        />
        <img
          class="image_39"
          referrerpolicy="no-referrer"
          v-lazy="'https://web-cdn.ktangtang.com/official-website/solution_h5/FigmaDDSSlicePNG28fb40480630188a21cbd8883956b251.png'"
        />
        <img
          class="image_40"
          referrerpolicy="no-referrer"
          v-lazy="'https://web-cdn.ktangtang.com/official-website/solution_h5/FigmaDDSSlicePNG56e86d642286fcd631d21b2fd4692a6f.png'"
        />
        <img
          class="image_41"
          referrerpolicy="no-referrer"
          v-lazy="'https://web-cdn.ktangtang.com/official-website/solution_h5/FigmaDDSSlicePNG6e983b5e2471ed1c5f7024c22ef5c273.png'"
        />
        <img
          class="image_42"
          referrerpolicy="no-referrer"
          v-lazy="'https://web-cdn.ktangtang.com/official-website/solution_h5/FigmaDDSSlicePNG0d9ad919e9d0142ef3225f57cb9238ca.png'"
        />
        <img
          class="thumbnail_16"
          referrerpolicy="no-referrer"
          v-lazy="'https://web-cdn.ktangtang.com/official-website/solution_h5/FigmaDDSSlicePNG7b1d2039782e29ca05547eeefe55996a.png'"
        />
      </div>
    </div>
   <footerMask/>
    <img
      class="image_45"
      referrerpolicy="no-referrer"
      v-lazy="'https://web-cdn.ktangtang.com/official-website/solution_h5/FigmaDDSSlicePNG36f687d7a1e324e88c0e7a2e52d37b75.png'"
    />
  </div>
</template>
<script>
import headerMask from "../../components/headery";
import footerMask from "../../components/footert";

export default {
  components: {
    headerMask,
    footerMask
  },
  data() {
    return {
      constants: {}
    };
  },
  async mounted() {
    
    let weight = window.screen.width
    console.log(weight, 'ddddddddddddd')
    if(weight >= 1200){
      this.$router.push({path: '/solution'})
    }
  
  },
  methods: {}
};
</script>
<style scoped lang="css" src="./assets/index.response.css" />